module.exports = {
  DataInvoice_NotPresent: {
    key: "DataInvoice_NotPresent",
    desc:
      "Fattura non generata, i dati di fatturazione non sono presenti ",
  },
}